"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgDataOutline = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { clipRule: 'evenodd', d: 'M20 14v-3.999H5.6L4 10v4h16zm0-6V4.001H5.6L4 4v4h16zM4 2h15.99C21.33 2 22 2.668 22 4v15.92c0 1.387-.667 2.08-2 2.08H4c-1.333 0-2-.693-2-2.08V4c0-1.333.667-2 2-2zm1.6 14H4v4h16v-3.999H5.6V16zM6 7a1 1 0 110-2 1 1 0 010 2zm0 6a1 1 0 110-2 1 1 0 010 2zm0 6a1 1 0 110-2 1 1 0 010 2z' }))); };
exports.default = SvgDataOutline;
//# sourceMappingURL=DataOutline.js.map